export enum DataMonitoringRuleType {
  DATA_EXCEPTION = 1,
  COMMUNICATION_STATUS = 2,
}

export const DataMonitoringRuleTypeDisplay = {
  [DataMonitoringRuleType.DATA_EXCEPTION]: '数据异常监测',
  [DataMonitoringRuleType.COMMUNICATION_STATUS]: '通讯状态监测',
};

export const dataMonitoringRuleTypeOptions = [
  {
    label: DataMonitoringRuleTypeDisplay[DataMonitoringRuleType.COMMUNICATION_STATUS],
    value: DataMonitoringRuleType.COMMUNICATION_STATUS,
  },
  {
    label: DataMonitoringRuleTypeDisplay[DataMonitoringRuleType.DATA_EXCEPTION],
    value: DataMonitoringRuleType.DATA_EXCEPTION,
  },
];

export enum DataMonitoringRuleStatus {
  DISABLE = 0,
  ENABLE = 1,
}

export const DataMonitoringRuleStatusDisplay = {
  [DataMonitoringRuleStatus.DISABLE]: '禁用',
  [DataMonitoringRuleStatus.ENABLE]: '启用',
};
